export var FormComponentType;
(function (FormComponentType) {
    FormComponentType["Radio"] = "radio_list";
    FormComponentType["Checkbox"] = "checkbox_list";
    FormComponentType["Text"] = "text_input";
})(FormComponentType || (FormComponentType = {}));
